// src/pages/LoginSSO.js
import React from "react";
import { useMsal } from "@azure/msal-react";

export default function LoginSSO() {
  const { instance } = useMsal();

  const login = () => {
    instance.setActiveAccount(null);
    instance.loginRedirect({
        scopes: [
          "openid",
          "profile",
          "User.Read",
          `api://${process.env.REACT_APP_AZURE_CLIENT_ID}/access_as_user`
        ],
        redirectUri: process.env.REACT_APP_AZURE_REDIRECT_URI,
        prompt: "select_account" 
      });
  };

  return (
    <div style={pageWrapper}>
      <div style={card}>
        <h2 style={title}>AI Quest</h2>
        <p style={subtitle}>Sign in securely using SSO</p>

        <button style={btn} onClick={login}>
          🔐 Sign in with SSO
        </button>
      </div>
    </div>
  );
}

const pageWrapper = {
  minHeight: "100vh",
  background: "radial-gradient(circle at top,#031b3d,#000814)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const card = {
  padding: 32,
  width: 360,
  borderRadius: 16,
  background: "rgba(3,18,40,0.8)",
  border: "1px solid #4ea1ff",
  textAlign: "center",
};

const title = { color: "white", fontSize: 26, fontWeight: 800, marginBottom: 8 };
const subtitle = { color: "#9ecbff", fontSize: 14, marginBottom: 20 };

const btn = {
  padding: "12px 18px",
  width: "100%",
  borderRadius: 12,
  background: "linear-gradient(90deg,#2563eb,#3b82f6)",
  color: "white",
  border: "none",
  cursor: "pointer",
  fontSize: 16,
  fontWeight: 600,
};
